import React from "react";

const LoginHeader = () => {
  return (
    <div className="flex flex-col items-center mb-8">
      <img
        src="/LogoLiberty.png"
        alt="Liberty Latin America"
        className="h-25 mb-4 brightness-0 invert"
      />
      <p className="text-xl font-bold text-[#F26522] mt-1">
        Cloud Engineering Services Portal
      </p>
    </div>
  );
};

export default LoginHeader;
